import { useState } from "react";
import { format } from "date-fns";
import { FolderOpen } from "lucide-react";
import { trpc } from "@/lib/trpc";
import { formatFileSize } from "@/lib/files-format";
import { fileIconFor, type FileRow } from "@/components/files/files-types";
import { FilePreviewDialog } from "@/components/files/FilePreviewDialog";
import { Card, CardEmpty, CardLoading, Rodape, VerTodos, linhaDoQuadro } from "./QuadroBase";
import type { QuadroProps } from "./tipos";

/** Os quatro arquivos mais novos do paciente; tocar abre a visualização. */
export function QuadroArquivos({ patientId, menu, irParaAba }: QuadroProps) {
  const query = trpc.file.listByEntity.useQuery({ relatedType: "PATIENT", relatedId: patientId });
  const [aberto, setAberto] = useState<FileRow | null>(null);
  const arquivos = ((query.data ?? []) as FileRow[]).slice(0, 4);

  return (
    <Card icon={<FolderOpen className="h-4 w-4" />} title="Arquivos recentes" tone="sky" menu={menu}>
      {query.isLoading ? (
        <CardLoading />
      ) : arquivos.length === 0 ? (
        <CardEmpty icon={<FolderOpen className="h-6 w-6" />} text="Nenhum arquivo ainda" hint="Fotos, exames e documentos do paciente aparecerão aqui" />
      ) : (
        <ul className="space-y-2">
          {arquivos.map((f) => {
            const Icone = fileIconFor(f.contentType);
            return (
              <li key={f.id}>
                <button type="button" onClick={() => setAberto(f)} className={`${linhaDoQuadro} items-center`}>
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-sky-50 text-sky-600 dark:bg-sky-500/10 dark:text-sky-400">
                    <Icone className="h-4 w-4" />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate text-sm font-medium text-zinc-900 dark:text-foreground">{f.name}</span>
                    <span className="block text-[11px] text-zinc-500 dark:text-muted-foreground">
                      {format(new Date(f.createdAt), "dd/MM/yyyy")} · {formatFileSize(f.size)}
                    </span>
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      )}
      <Rodape>
        <VerTodos rotulo="Ver todos os arquivos" onClick={() => irParaAba("arquivos")} />
        <span />
      </Rodape>
      <FilePreviewDialog file={aberto} onClose={() => setAberto(null)} />
    </Card>
  );
}
